<template>
  <div class="editor-block-tabs flex flex-col">
    <div
      class="editor-block-tabs-item"
      :class="{ active: displayType === 'editor' }"
      @click="clickTab('editor')"
    >
      <span>简历编辑</span>
    </div>
    <div
      class="editor-block-tabs-item"
      :class="{ active: displayType === 'template' }"
      @click="clickTab('template')"
    >
      <span>简历模版</span>
    </div>
    <div
      class="editor-block-tabs-item"
      :class="{ active: displayType === 'aiMentor' }"
      @click="clickTab('aiMentor')"
    >
      <span>AI导师</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "EditorBlockTabs",
  props: {
    displayType: {
      type: String,
      default: "editor",
    },
  },
  methods: {
    clickTab(type) {
      this.$emit("clickTab", type);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.editor-block-tabs-item {
  @apply flex justify-center items-center cursor-pointer;
  width: 92px;
  height: 77px;
  border-radius: 0px 12px 12px 0px;
  color: $editor-tab-default-color;
  &.active {
    background-color: $editor-tab-bg-active-color;
    span {
      background: linear-gradient(
        to right,
        $editor-tab-text-color-start 0%,
        $editor-tab-text-color-end 100%
      );
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
}
</style>
